import { DateTimeFmt } from "../../../utils/DataUtils";

const STATUS_CLASS = {
    ESTOQUE: "ok",
    CURVANDO: "info",
    RESERVADO: "warn",
    MANUTENCAO: "danger",
};

// Mesma regra da tela Status Molde: vermelho no limite, amarelo faltando 1.
const passagensNivel = (qtd, max) => {
    if (!max) return "";
    if (qtd >= max) return "danger";
    if (max - qtd <= 1) return "warn";
    return "";
};

// Código do molde da ordem e todos os lotes dele; o lote usado no forno fica no topo, destacado.
function MoldeInfo({ molde }) {
    const isUsado = (m) => !!molde.loteUsado && String(m.molde_Lote) === String(molde.loteUsado);
    const lotes = [...molde.lotes].sort((a, b) => isUsado(b) - isUsado(a));
    const emEstoque = lotes.filter((m) => m.molde_Status === "ESTOQUE").length;

    return (
        <div className="molde-info">
            <div className="molde-info-header">
                <div>
                    <div className="molde-info-codigo">Molde {molde.codigo}</div>
                    {molde.descricao && <div className="molde-info-desc">{molde.descricao}</div>}
                </div>
                <div className="molde-info-resumo">
                    <span><b>{lotes.length}</b> lotes</span>
                    <span><b>{emEstoque}</b> em estoque</span>
                </div>
            </div>

            {lotes.length === 0 ? <p className="molde-info-vazio">Nenhum lote cadastrado para este molde.</p> : (
                <div className="molde-info-tabela">
                    <table>
                        <thead>
                            <tr>
                                <th>Lote</th>
                                <th>Status</th>
                                <th>Passagens</th>
                                <th>SAP Local</th>
                                <th>Última Manutenção</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lotes.map((m) => {
                                const qtd = m.molde_QtdPassagens ?? 0;
                                const max = m.molde_QtdPassagensMAX;
                                const pct = max ? Math.min(100, (qtd / max) * 100) : 0;
                                const nivel = passagensNivel(qtd, max);
                                return (
                                    <tr key={m.molde_Key} className={isUsado(m) ? "molde-usado" : undefined}>
                                        <td>
                                            <span className="molde-info-lote">{m.molde_Lote}</span>
                                            {isUsado(m) && <span className="molde-usado-tag">Usado no forno</span>}
                                        </td>
                                        <td>
                                            <span className={`molde-status ${STATUS_CLASS[m.molde_Status] ?? ""}`}>
                                                {m.molde_Status}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="molde-passagens">
                                                <span className={nivel}>{qtd} / {max ?? "-"}</span>
                                                {max > 0 && (
                                                    <div className="molde-passagens-barra">
                                                        <div className={nivel} style={{ width: `${pct}%` }} />
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>{m.molde_SAPLocal || "—"}</td>
                                        <td>{DateTimeFmt(m.molde_DtManutencao) || "Sem registro"}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default MoldeInfo;
